module.exports = __webpack_public_path__ + "img/dg-nav-below-nav-toyota.7371598a.png";